module.exports = __webpack_public_path__ + "static/media/RideNowLogo.f2cd4a3b.png";